import { prop } from "ramda";
import { createSelector } from "reselect";
import { STATE_IDENTIFIER } from "./tcConstants";

const { TABLES_CONFIGURATION } = STATE_IDENTIFIER;

const tablesConfigurationSelector = (state: any) => state.tablesConfiguration;

export const selectTablesConfiguration: any = createSelector(
  tablesConfigurationSelector,
  prop(TABLES_CONFIGURATION)
);
